import {
  Table, TableHead, TableHeadCell, TableBody, TableRow,
} from "flowbite-react";
import { ExpenseRowSkeleton } from "@/features/vouchers";

export const ExpensesListSkeleton = () => {
  return (
    <div className="overflow-x-auto">
      <Table hoverable>
        <TableHead className="uppercase">
          <TableRow>
            <TableHeadCell>Date</TableHeadCell>
            <TableHeadCell>Marchand</TableHeadCell>
            <TableHeadCell>Montant</TableHeadCell>
            <TableHeadCell>Ref</TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody className="divide-y divide-border dark:divide-darkborder">
          {Array.from({ length: 10 }, (_, index) => (
            <ExpenseRowSkeleton key={index} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
